'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /**
                                                                                                                                                                                                                                                                   * 展示金额，一般要求数字保留两位小数，并在前面加上人民币符号
                                                                                                                                                                                                                                                                   */


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (props) {
    var money = Number.parseFloat(props.money).toFixed(2);
    var leftProps = _extends({}, props);
    delete leftProps.money;
    return _react2.default.createElement(
        'span',
        leftProps,
        '\uFFE5',
        money
    );
};


//////////////////
// WEBPACK FOOTER
// ./src/js/components/currency_display.js
// module id = 1331
// module chunks = 0